module.exports = __webpack_public_path__ + "e68a4ddd3724ebc72bd360f04f881771.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/header/components/images/umac-header-bg.jpg
 ** module id = 1389
 ** module chunks = 0
 **/